import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { CheckmarkComponent } from './components';

@NgModule({
  declarations: [CheckmarkComponent],
  imports: [CommonModule],
  exports: [CheckmarkComponent],
})
export class CheckmarkModule {}
